import base from '@/http/url_base';

export default {
  MISSION: base.API_CRM + '/missions',
  MISSION_START: '/start',
  MISSION_PAUSE: '/pause/',
  MISSION_CONTINUE: '/continue',
  MISSION_CLOSE: '/close',
  MISSION_FINISH: '/finish',
  MISSION_RESET: '/reset',
  MISSION_TACHE: '/taches',
};
